import request from "./client";

export type PropertyRecord = {
  id: number;
  property_name: string;
  address_line_1: string;
  address_line_2?: string | null;
  city: string;
  county?: string | null;
  postcode: string;
  total_rooms: number;
  created_at?: string;
};

export async function getProperties() {
  return request<PropertyRecord[]>("/api/properties");
}

export async function createProperty(payload: Record<string, unknown>) {
  return request<PropertyRecord>("/api/properties", {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export async function updateProperty(
  id: number,
  payload: Record<string, unknown>,
) {
  return request<PropertyRecord>(`/api/properties/${id}`, {
    method: "PUT",
    body: JSON.stringify(payload),
  });
}

export async function deleteProperty(id: number) {
  return request<{ success: boolean }>(`/api/properties/${id}`, {
    method: "DELETE",
  });
}
